'use client';

import { c as _c } from "react/compiler-runtime";
import { useSelector } from '@legendapp/state/react';
import { useEffect } from 'react';
import { headerState$ } from '@/components/SiteHeader/HeaderScrollAutoHide';
import { Typography } from '@/components/Typography';
import type { CommonCmsBlockProps } from '@/components/blocks/CmsBlock';
import { useStickySentinel } from '@/hooks/useStickySentinel';
import { cn } from '@/lib/cn';
import type { ExcessProducts } from './excessProducts';
export interface FleetCategoryExcessGridHeaderProps extends CommonCmsBlockProps {
  excess: ExcessProducts;
  children?: React.ReactNode;
}
export function FleetCategoryExcessGridHeader(t0) {
  const $ = _c(21);
  const {
    excess,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      offsetPx: 112,
      onChange: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    topSentinelRef,
    bottomSentinelRef,
    state
  } = useStickySentinel(t1);
  const isHeaderHidden = useSelector(headerState$.hidden);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  useEffect(_temp3, t2);
  let t3;
  if ($[2] !== topSentinelRef) {
    t3 = <div ref={topSentinelRef} className="h-px w-full block sm:hidden" />;
    $[2] = topSentinelRef;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = state.isStuck && !isHeaderHidden;
  const t5 = !state.isStuck;
  let t6;
  if ($[4] !== state.isStuck || $[5] !== t4 || $[6] !== t5) {
    t6 = cn("bg-primary grid grid-cols-3 md:grid-cols-4 text-center sticky sm:relative top-0 sm:top-auto transition-all duration-300 ease-in-out", {
      "top-28 sm:top-auto": t4,
      "card-shadow sm-shadow-none": state.isStuck,
      "rounded-t-2xl": t5
    });
    $[4] = state.isStuck;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="hidden md:block" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== excess) {
    t8 = excess.map(_temp4);
    $[9] = excess;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t6 || $[12] !== t8) {
    t9 = <div className={t6}>{t7}{t8}</div>;
    $[11] = t6;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== bottomSentinelRef) {
    t10 = <div ref={bottomSentinelRef} className="h-px w-full block sm:hidden outline-1" />;
    $[14] = bottomSentinelRef;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== children || $[17] !== t10 || $[18] !== t3 || $[19] !== t9) {
    t11 = <>{t3}{t9}{children}{t10}</>;
    $[16] = children;
    $[17] = t10;
    $[18] = t3;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  return t11;
}
function _temp4(product, index) {
  return <Typography noProse={true} as="div" variant="h6" className="excess-grid-header text-white py-4 px-4" key={`${product.name}-${index}`}><span className="line-clamp-2 overflow-hidden">{product.label}</span></Typography>;
}
function _temp3() {
  return _temp2;
}
function _temp2() {
  return headerState$.hasSubNav.set(false);
}
function _temp(t0) {
  const {
    isStuck
  } = t0;
  headerState$.hasSubNav.set(isStuck);
}